import { Component } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { ButtonComponent } from '@recruitee/user-interface';

import { environment } from '../../environments/environment';

@Component({
  selector: 'rto-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.less'],
  imports: [ButtonComponent, TranslatePipe],
})
export class NotFoundComponent {
  public tellentAuthUrl: string = environment.tellentAuthUrl;
}
